import { CircularProgress, styled } from '@ori-ui/mui';
import { memo } from 'react';

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
});

export const Loading = memo(() => (
  <Root>
    <CircularProgress color="primary" />
  </Root>
));
